import { DataSourceType } from "../../types";

type ResolveShouldFilterNsfwCharactersForDataSourceParameters = {
  shouldFilterNsfwCharacters?: boolean;
  dataSourceType: DataSourceType;
};

const resolveShouldFilterNsfwCharactersForDataSource = ({
  shouldFilterNsfwCharacters,
  dataSourceType,
}: ResolveShouldFilterNsfwCharactersForDataSourceParameters): boolean => shouldFilterNsfwCharacters ?? dataSourceType !== DataSourceType.MY_CHATBOTS;

export default resolveShouldFilterNsfwCharactersForDataSource;
